// Was a BS3 feature
$(document).ready(function() {
    $('[data-toggle="buttons"]').find('input').each(function() {
        var $this = $(this);
        var $button = $this.closest('button');

        var handleChange = function(elem) {
            elem.show().siblings().hide()
        }
        var $target = $($button.data('target'));

        $this.on('change', function() {
            handleChange($target);
        });

        if($this.prop("checked") == true) {
            handleChange($target);
            $button.addClass('active');
        }
    });
});
